import React from "react";

import { withRouter } from "react-router-dom";

import PrintReceiptsService from "../../../services/printReceipts/PrintReceiptsService";

import AdminPage from "./../common/AdminPage";
import PrintReceipts from "@cdkglobal/epay-admin-component/cjs/components/_onePay/middle/printReceipts/PrintReceipts";

const PrintReceiptsPage = ({ history }) => {
  return (
    <AdminPage showGoBackLink={true} history={history} backPage={""}>
      <PrintReceipts
        onSearchReceipts={PrintReceiptsService.search}
        loadReceiptDetails={PrintReceiptsService.listReceiptDetails}
        onSendEmail={PrintReceiptsService.sendEmail}
      />
    </AdminPage>
  );
};

export default withRouter(PrintReceiptsPage);
